import type { ReactNode } from 'react';

export interface TableScrollProps {
  children: ReactNode;
  className?: string;
}

/**
 * Horizontal scroll wrapper for data tables on narrow viewports.
 * Negative margin on phone allows edge-to-edge scroll inside padded pages.
 */
export default function TableScroll({
  children,
  className = '',
}: TableScrollProps): React.ReactElement {
  return (
    <div className={`overflow-x-auto -mx-4 px-4 sm:mx-0 sm:px-0 ${className}`.trim()}>
      {children}
    </div>
  );
}
